var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.841,
    height: 37.149,
    viewBox: "0 0 47.841 37.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(0 -66.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_947",
    "data-name": "Caminho 947",
    d: "M72.763,188.765a3.836,3.836,0,1,0,3.836-3.85A3.847,3.847,0,0,0,72.763,188.765Zm3.836-2.379a2.379,2.379,0,1,1-2.366,2.379A2.375,2.375,0,0,1,76.6,186.385Z",
    transform: "translate(-65.63 -106.798)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_948",
    "data-name": "Caminho 948",
    d: "M45.593,69.395a.678.678,0,0,0-.99-.044.761.761,0,0,0-.042,1.039,7.678,7.678,0,0,1,1.878,5.067,7.3,7.3,0,0,1-7.092,7.475,7.486,7.486,0,0,1,0-14.951,6.735,6.735,0,0,1,2.8.6.689.689,0,0,0,.921-.384.749.749,0,0,0-.366-.966,8.074,8.074,0,0,0-3.353-.724,8.479,8.479,0,0,0-7.636,5.031H1.258A1.293,1.293,0,0,0,0,72.864v29.474a1.293,1.293,0,0,0,1.258,1.322H43.946a1.293,1.293,0,0,0,1.258-1.322V92.045a.7.7,0,1,0-1.4,0V102.19H1.4V73.012H31.175a9.308,9.308,0,0,0-.271,1.465H11.4a.736.736,0,0,0,0,1.47H30.866A8.71,8.71,0,0,0,39.347,84.4a8.086,8.086,0,0,0,1.669-.174v10.49L36.9,88.56a1.038,1.038,0,0,0-1.789,0l-4.021,6.02L23.555,83.294a1.038,1.038,0,0,0-1.789,0L14.208,94.611,10.167,88.56a1.038,1.038,0,0,0-1.789,0L4.188,94.833V75.948H8.129a.736.736,0,0,0,0-1.47H4.044A1.293,1.293,0,0,0,2.786,75.8V99.4a1.293,1.293,0,0,0,1.258,1.322H41.159A1.293,1.293,0,0,0,42.418,99.4V83.8a8.316,8.316,0,0,0,1.385-.728v5.447a.7.7,0,1,0,1.4,0V81.929a9.28,9.28,0,0,0,.389-12.535ZM4.188,99.254V97.4l5.084-7.612L15.6,99.254Zm13.121,0-2.245-3.362,7.6-11.375L32.5,99.254Zm23.707,0h-6.8l-2.266-3.393,4.06-6.078,5.007,7.5v1.974Z",
    transform: "translate(0)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_949",
    "data-name": "Caminho 949",
    d: "M381.577,100.275a1.128,1.128,0,0,0-.841.376l-3.168,3.547a1.127,1.127,0,0,0,.841,1.878h1.109v4.54a1.129,1.129,0,0,0,1.127,1.127h1.862a1.129,1.129,0,0,0,1.127-1.127v-4.54h1.109a1.127,1.127,0,0,0,.841-1.878l-3.168-3.546A1.129,1.129,0,0,0,381.577,100.275Zm1.323,4.331a.735.735,0,0,0-.735.735v4.932h-1.176v-4.932a.735.735,0,0,0-.735-.735h-1.078l2.4-2.688,2.4,2.688Z",
    transform: "translate(-342.648 -30.454)",
    fill: "#d4af37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadActivity);
export default __webpack_public_path__ + "static/media/uploadActivity.0468d2c6711d3a4d079ebbdd0234c5fb.svg";
export { ForwardRef as ReactComponent };